module.exports = __webpack_public_path__ + "img/equityFinancing.974bdb35.png";